<template>
  <router-view />
</template>

<script>
export default {
  name: "MonitoringMain",
};
</script>

<style>
</style>